import { Title } from "components";
import { Contact } from "./components";

export default function Connect() {
  return (
    <div className="h-screen flex flex-col lg:justify-center items-center">
      <div className="lg:w-[600px]">
        <Title className="mb-6 mt-8 lg:mt-0">CONTACT</Title>
        <Contact />
      </div>
    </div>
  );
}
